import { ProtocolValue } from './chunk-KQLD5VJQ.js';
import { decodedOf, rawOf, displayOf } from '@authe/fe-commons/storage';
import { jsxs, jsx } from 'react/jsx-runtime';

function TokenQuantity({ value, fungible = true }) {
  const decoded = decodedOf(value);
  const hasScale = typeof decoded?.decimals === "number" && Number.isInteger(decoded.decimals) && decoded.decimals >= 0 && decoded.decimals <= 36 && (decoded.amount != null || decoded.value != null);
  const integer = (item) => (typeof item === "string" || typeof item === "bigint" || typeof item === "number") && /^(?:-?\d+|0x[\da-f]+)$/i.test(String(item));
  const unscaled = fungible && !hasScale && integer(rawOf(value)) && integer(displayOf(value));
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
    /* @__PURE__ */ jsx(ProtocolValue, { value }),
    unscaled && /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", title: "Token decimals are unavailable for this argument. This is the exact unscaled amount.", children: "base units" })
  ] });
}

export { TokenQuantity };
//# sourceMappingURL=chunk-OKLM3BVS.js.map
//# sourceMappingURL=chunk-OKLM3BVS.js.map